// One clean slider look everywhere: the fill follows the thumb via --p (0..1), kept in sync here.
const sync = (el: HTMLInputElement) => {
  const min = Number(el.min || 0), max = Number(el.max || 100), v = Number(el.value);
  const p = max > min ? (v - min) / (max - min) : 0;
  el.style.setProperty('--p', String(Math.max(0, Math.min(1, p))));
};
if (typeof document !== 'undefined') {
  document.addEventListener('input', e => { const t = e.target as HTMLInputElement; if (t?.type === 'range') sync(t); }, true);
  let q = false;
  const scan = () => { q = false; document.querySelectorAll<HTMLInputElement>('input[type=range]').forEach(sync); };
  new MutationObserver(() => { if (!q) { q = true; requestAnimationFrame(scan); } }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
  setInterval(scan, 1000); // React updates .value as a property, not an attribute
  scan();
}
export {};
